export const environment = {
    production: true,
    domain: '.corridordigital.com',
    host: 'corridordigital.com',
    socketUrl: 'https://socket.corridordigital.com',
    samsung: false,
    recaptchaKey: '6Le9MhgqAAAAANsgEdwnPNxicOKNdqiixE2L0P7k',
};
